import { combineReducers } from "@reduxjs/toolkit";

import globalSlice from "./globalSlice";
import posConfigReducer from "../pages/Applications/Pos/PosProjectSetup/PosConfigurationModal/posConfigSlice";
import scanToSlice from "./scanToSlice";
import fidelityReducer from "./slices/fidelitySlice";
import servioSlice from "./servioSlice";

// connected-react-router was removed (it's unmaintained since 2021 and ties
// us to react-router-dom v5). Navigation is now done with RRD v6 hooks
// (useNavigate / <Navigate>) and direct window.location calls in sagas.
const createRootReducer = () =>
    combineReducers({
        global: globalSlice,
        posConfig: posConfigReducer,
        scanTo: scanToSlice,
        fidelity: fidelityReducer,
        servio: servioSlice,
    });

export default createRootReducer;
